export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://stage-craft.cinestar.cz/api", "defaultOptions": {"query": {"fetchPolicy": "no-cache"}, "watchQuery": {"fetchPolicy": "no-cache"}}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie"}}
}